var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.visibility)?_c('div',[_c('div',{class:{ loader: true, boxed: !!_vm.boxed }},[_c('spinner')],1)]):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }